import React from 'react';
import CRUDDetailPage from '../../../shared/components/crud/CRUDDetailPage';
import { parentRecordConfig } from '../config/index';
import { PatientService } from '../../../shared/services/patientService';

/**
 * PatientDetail - URL-based detail page for Patients
 * Handles view, edit, and add modes with ID from URL params
 */
export default function PatientDetail() {
  return (
    <CRUDDetailPage
      config={parentRecordConfig}
      service={PatientService}
    />
  );
}
